import React from 'react';

import { Block, withConfig } from '../common/Block.jsx';
import { EmptyPlaceholder } from '../layout/Builder.jsx';
import { Clickable } from '../common/Button.jsx';
import { Column, Container, Row } from '../common/Container.jsx';
import Defaults from '../layout/Defaults.jsx';
import HeaderText from './HeaderText.jsx';
import { default as _Image, ImageBlockV1, ImageBlockV2, ImageSrcSet } from '../common/Image.jsx';
import Kit from '../layout/Kit.jsx';
import Name from '../common/Name.jsx';
import PageType from '../common/PageType.jsx';
import Token from '../common/Token.jsx';

// region LEGACY

class _ArtistBioComponent extends React.Component {
    constructor(props) {
        super(props);

        let display;
        if (props.data) {
            display = props.data.bio || props.data.display;
        }
        this.state = {
            content: display,
            expanded: false
        };

        this.handleToggleExpansion = this.handleToggleExpansion.bind(this);
    }

    componentDidMount() {
        this.setState({
            id: `artistBio-${this.props.blockIdentifier}`
        });
    }

    handleToggleExpansion() {
        const expanded = !this.state.expanded;
        this.setState({
            expanded: expanded
        });
    }

    render() {
        if (!this.state.content || this.state.content.length == 0) {
            if (this.props.builder) {
                return <EmptyPlaceholder />
            }
            return null;
        }

        let descriptionClassName = 'artist__content description';
        let contentContainerSize, image, imageWrapperClassName;
        if (this.state.expanded) {
            descriptionClassName += ' artist__content--show';
        }
        if (this.props.data.profile) {
            contentContainerSize = '8';

            const profile = this.props.data.profile;
            const imageTuples = _Image.sizes.map(function (d) {
                return { size: d, url: _Image.url(profile, d, d, 'c_fill') };
            });
            image = (
                <ImageSrcSet
                    className="artist__card__img"
                    builder={this.props.builder}
                    config={this.props.config}
                    data={{ alt: this.props.data.name, title: this.props.data.name }}
                    imageTuples={imageTuples}
                    serverSide={this.state.id == undefined} />
            );
            imageWrapperClassName = 'col--4';
        } else {
            contentContainerSize = '12';
        }
        const blockConfig = this.props.onNormalizeBlockConfig(this.props);
        let buttonDisplayCollapse, buttonDisplayExpand, margin, maxWidth, styleBlock, styleLayout;
        if (this.props.blockConfig) {
            if (this.props.blockConfig.block) {
                styleBlock = {};
                Block.mapStyleConfigProps(styleBlock, this.props.blockConfig.block, (propName, propValue) => {
                    switch (propName) {
                        case 'buttonDisplayCollapse':
                            buttonDisplayCollapse = propValue;
                            return true;
                        case 'buttonDisplayExpand':
                            buttonDisplayExpand = propValue;
                            return true;
                        case 'isExpanded':
                            if (propValue) {
                                descriptionClassName += ' artist__content--show';
                            }
                            return true;
                    }
                });
            }
            if (this.props.blockConfig.layout) {
                styleLayout = {};
                Block.mapStyleConfigProps(styleLayout, this.props.blockConfig.layout, (propName, propValue, propUnit) => {
                    switch (propName) {
                        case 'alignment':
                            if (!this.props.inLayout) {
                                margin = Block.marginForAlignment(propValue);
                            }
                            return true;
                        case 'maxWidth':
                            if (propValue && propUnit) {
                                maxWidth = `${propValue}${propUnit}`;
                            }
                            return true;
                    }
                });
            }
        }
        if (blockConfig.isExpanded) {
            descriptionClassName += ' artist__content--show';
            if (styleBlock) {
                styleBlock.marginBottom = undefined;
            }
        }
        if (image) {
            image = (
                <Column className={imageWrapperClassName}>
                    <div className="artist__card artist__card--single">
                        {image}
                    </div>
                </Column>
            );
        }
        let expandButtonStyle;
        if (this.props.builder) {
            expandButtonStyle = { pointerEvents: 'none' };
        }
        let styleContainer;
        if (maxWidth) {
            styleContainer = { margin: margin, maxWidth: maxWidth };
        }
        return (
            <Container className="cont--spaced cont--spaced--lg" id={this.state.id} style={styleContainer}>
                <Row style={styleLayout}>
                    {image}
                    <Column className="artist__content--container" size={contentContainerSize}>
                        <div className={descriptionClassName} dangerouslySetInnerHTML={{ __html: this.state.content }} style={styleBlock}></div>
                        {
                            !blockConfig.isExpanded &&
                            <span className="artist__content--more">
                                <Clickable style={expandButtonStyle} onClick={this.handleToggleExpansion}>{this.state.expanded ? (buttonDisplayCollapse || 'Show Less') : (buttonDisplayExpand || 'Read More')}</Clickable>
                            </span>
                        }
                    </Column>
                </Row>
            </Container>
        );
    }
}
const ArtistBioComponent = withConfig(_ArtistBioComponent);
const Legacy = { Component: ArtistBioComponent };

// #region IMAGE V1

function ArtistImageV1Component(props) {
    const data = props.data || {};
    return (
        <ImageBlockV1.Component
            blockConfig={props.blockConfig}
            builder={props.builder}
            className="artist__img--cont"
            config={props.config}
            display={data.name}
            image={data.profile}
            imageClassName="artist__img"
            inCell={props.inCell}
            inLayout={props.inLayout}
            pageType={props.pageType} />
    );
}
const ImageV1 = { Component: ArtistImageV1Component };

// #endregion IMAGE V1

// #region IMAGE V2

function ArtistImageV2Component(props) {
    const data = props.data || {};
    let image = data.profile;
    if (props.blockConfig && props.blockConfig.layout) {
        switch (props.blockConfig.layout.source) {
            case 'cover':
                image = data.cover;
                break;
        }
    }
    return (
        <ImageBlockV2.Component
            {...props}
            alt={data.name}
            className="artist__img--cont"
            image={image}
            imageClassName="artist__img"
            imageId={image && image.id} />
    );
}
const ImageV2 = { Component: ArtistImageV2Component };

// #endregion IMAGE V2

// #region NAME V1

function _ArtistNameV1Component(props) {
    let style = {};
    if (props.blockConfig && props.blockConfig.container) {
        Block.mapStyleConfigProps(style, props.blockConfig.container);
    }
    let className = 'cont--artist__name';
    if (!props.inLayout) {
        className += ' cont--kit__content';
    }
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit(style, props);
    return (
        <div className="cont--kit__wrapper" style={layoutStyles.containerStyle}>
            {
                props.content != undefined &&
                <div className={className} style={layoutStyles.style}>
                    <div className="cont--token" dangerouslySetInnerHTML={{ __html: props.content }} style={{ lineHeight: 1 }} />
                </div>
            }
            {
                props.builder &&
                (props.content == undefined || props.content.length == 0) &&
                <EmptyPlaceholder />
            }
        </div>
    );
}
const ArtistNameV1Component = Token.withContentTokenParsing(_ArtistNameV1Component, { headerConversionMap: { [Token.ArtistName]: 'h1' } }, (props, keyword, options) => Token.parsing.artist(props.data, keyword, options));
const ArtistNameV1InventoryComponent = Token.withContentTokenParsing(_ArtistNameV1Component, { headerConversionMap: { [Token.ArtistName]: 'h2' } }, (props, keyword, options) => Token.parsing.artist(props.data, keyword, options));
const ArtistNameTokens = () => {
    return [
        Token.getWrappedTokenConfig('Artist Name', Token.ArtistName),
        Token.getWrappedTokenConfig('Artist Lifespan', Token.ArtistLifespan)
    ];
}
const NameV1 = { Component: ArtistNameV1Component, InventoryComponent: ArtistNameV1InventoryComponent, Tokens: ArtistNameTokens };

// #endregion NAME V1

// #region NAME V2 (-- DEPRECATED Use `ArtistNameV1` --)

function ArtistNameV2Component(props) {
    return <HeaderText.TokenizedComponent {...props} className="cont--artist__name" defaultDesign={Defaults.Block[Name.Block.Artist.NameV2]} type={Kit.Type.ArtistDetail} />
}
const NameV2 = { Component: ArtistNameV2Component, Tokens: ArtistNameTokens };

// #endregion NAME V2

// #region TOKENIZED

function _ArtistBioTokenizedComponent(props) {
    const [expanded, setExpanded] = React.useState(false);
    const handleToggleExpansion = () => { setExpanded(!expanded) }

    let buttonDisplayCollapse = 'Show Less';
    let buttonDisplayExpand = 'Read More';
    let showFullBiography = false;
    let maxHeight;
    const expandButtonStyle = { display: 'block' };
    if (props.blockConfig && props.blockConfig.block) {
        let value;
        for (let propName in props.blockConfig.block) {
            value = props.blockConfig.block[propName];
            switch (propName) {
                case 'buttonDisplayCollapse':
                    if (value && value.length > 0) {
                        buttonDisplayCollapse = value;
                    }
                    break;
                case 'buttonDisplayExpand':
                    if (value && value.length > 0) {
                        buttonDisplayExpand = value;
                    }
                    break;
                case 'isExpanded':
                    showFullBiography = value;
                    break;
                case 'maxHeight':
                    if (value && value.value && value.value.length > 0 && value.unit) {
                        maxHeight = `${value.value}${value.unit}`;
                    }
                    break;
                default:
                    const _propName = propName.replace('Button', '');
                    let _value = value;
                    if (_value && _value.unit) {
                        if (_value.value && _value.value.length > 0) {
                            _value = `${_value.value}${_value.unit}`;
                        } else {
                            _value = undefined;
                        }
                    }
                    expandButtonStyle[_propName] = _value;
                    break;
            }
        }
    }
    let bioClassName = 'cont--token artist__content';
    if (showFullBiography || expanded) {
        bioClassName += ' artist__content--show';
        maxHeight = undefined;
    }
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit({}, props);
    return (
        <div className="cont--kit__wrapper" style={layoutStyles.containerStyle}>
            {
                props.content != undefined &&
                <div className={!props.inLayout ? "cont--kit__content" : undefined} style={layoutStyles.style}>
                    <div className={bioClassName} dangerouslySetInnerHTML={{ __html: props.content }} style={{ height: maxHeight }}></div>
                    {
                        !showFullBiography &&
                        <span className="artist__content--more" style={expandButtonStyle}>
                            <Clickable style={props.builder ? { pointerEvents: 'none' } : undefined} onClick={handleToggleExpansion}>{expanded ? buttonDisplayCollapse : buttonDisplayExpand}</Clickable>
                        </span>
                    }
                </div>
            }
            {
                props.builder &&
                (props.content == undefined || props.content.length == 0) &&
                <EmptyPlaceholder />
            }
        </div>
    );
}
const ArtistBioTokenizedComponent = Token.withContentTokenParsing(_ArtistBioTokenizedComponent, {}, (props, keyword, options) => Token.parsing.artist(props.data, keyword, options));
const ArtistBioTokens = (pageType) => {
    switch (pageType) {
        case PageType.Custom:
            return [
                Token.getWrappedTokenConfig('Artist Biography', Token.ArtistBiography),
                Token.getWrappedTokenConfig('Artist CV', Token.ArtistCV)
            ];
        default:
            return [
                Token.getWrappedTokenConfig('Artist Name', Token.ArtistName),
                Token.getWrappedTokenConfig('Artist Lifespan', Token.ArtistLifespan),
                Token.getWrappedTokenConfig('Artist Biography', Token.ArtistBiography),
                Token.getWrappedTokenConfig('Artist CV', Token.ArtistCV),
                Token.getWrappedTokenConfig('Artist Country', Token.Address.Country),
                Token.getWrappedTokenConfig('Artist State', Token.Address.State)
            ];
    }
}
const Tokenized = { Component: ArtistBioTokenizedComponent, Tokens: ArtistBioTokens };

// #endregion TOKENIZED

export {
    ImageV2,
    NameV1,
    Tokenized,

    // DEPRECATED
    ImageV1,
    Legacy,
    NameV2
};